/** Team profiles migrated from the source site's `team` post type. */
export type TeamMember = {
  slug: string;
  name: string;
  role?: string;
  image: string;
  contentKey: string;
};

export const teamMembers: TeamMember[] = [
  {
    slug: "stephen-evans",
    name: "Stephen Evans",
    image: "/media/stephen2.webp",
    contentKey: "team__stephen-evans",
  },
  {
    slug: "alisa-evans",
    name: "Alisa Evans",
    image: "/media/PROFILE.webp",
    contentKey: "team__alisa-evans",
  },
  {
    slug: "steve-new",
    name: "Steve New",
    image: "/media/newsteve2.webp",
    contentKey: "team__steve-new",
  },
  {
    slug: "dennis-aplicano",
    name: "Dennis Aplicano",
    image: "/media/stevenew-12.webp",
    contentKey: "team__dennis-aplicano",
  },
  {
    slug: "alvaro-matehuala",
    name: "Alvaro Matehuala",
    image: "/media/AlvaroMatehuala.webp",
    contentKey: "team__alvaro-matehuala",
  },

];

export function findTeamMember(slug: string): TeamMember | undefined {
  return teamMembers.find((m) => m.slug === slug);
}
